const config = {
  oidc: {
    redirectUri: `${window.location.protocol}//${window.location.host}/implicit/callback`,
    pkce: true,
    disableHttpsCheck: false,
    tokenManager: {
      expireEarlySeconds: 120,
    },
  },
  app: {},
  path: {
    host: "/api/morph/",
  },
  apiUrls: {
    promosApi: "/api/promos",
    referenceData: "reference-data",
    users: "users/",
    jobs: "jobs/",
    requests: "requests/",
    jobsAction: "jobs/action/",
    jobTemplate: "job-template/",
    brandNames: "ref-data/networks",
    validateMultipleEdits: "/content-request/validateMultipleEdits",
    createBatchMediaRequest: "/content-request/batch",
    odsFetchSeasons: "/ods/fetchSeasons",
    odsAutosuggest: "/ods/autosuggestion",
    odsSearchByIds: "/ods/searchByIds",
    odsSearchMAMProxy: "/ods/searchProxy",
    searchLegacyGmsc: "/content-finder/search",
    fetchTitleDetails: "/content-finder/",
    banners: "banners",
  },
  groupClaimName: "ops.morph.groups",
  rbacRoles: [],
};

export default config;